import React from 'react'
import PropTypes from 'prop-types'
import { Box, Divider, makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  divider: {
    width: '100%',
    borderColor: 'var(--color-surface-100)' // divider
  }
}))

const AdvisorViewDivider = ({ className }) => {
  const classes = useStyles()
  return (
    <Box width='100%' py='0' className={className}>
      <Divider className={classes.divider} />
    </Box>
  )
}

AdvisorViewDivider.propTypes = {
  className: PropTypes.string
}

export default AdvisorViewDivider
